import { render } from "./tw-theme.vue?vue&type=template&id=56e81524"
import script from "./tw-theme.vue?vue&type=script&lang=js"
export * from "./tw-theme.vue?vue&type=script&lang=js"

import "./tw-theme.vue?vue&type=style&index=0&id=56e81524&lang=css"
script.render = render

export default script